export default {
  editDossierState: 'ok',
  addDossiersState: 'ok',
  listDossiersState: 'in-progress',
  listDossiersRecords: []
}
